import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.output.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { SupabaseAuthProvider } from './contexts/SupabaseAuthContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SupabaseAuthProvider>
      <AppRouter />
    </SupabaseAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
